
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/RedefinirSenha",
      function () {
        return require("private-next-pages/RedefinirSenha/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/RedefinirSenha"])
      });
    }
  